import type {Node, Point, Position} from 'unist'

interface PointWithOffset extends Point {
  offset: number
}

interface PositionWithOffsets extends Position {
  start: PointWithOffset
  end: PointWithOffset
}

export interface PositionedNode extends Node {
  position: PositionWithOffsets
}

/** Type guard to check if a node has a valid position as offsets into the document. */
export function isPositionedNode(node: Node): node is PositionedNode {
  return (
    node.position !== undefined &&
    node.position.start !== undefined &&
    node.position.end !== undefined &&
    typeof node.position.start.offset === 'number' &&
    typeof node.position.end.offset === 'number'
  )
}

/** Compare node positions for sorting. */
export function compareNodePositions(a: Node, b: Node): number {
  if (!isPositionedNode(a) || !isPositionedNode(b)) return 0
  if (a.position.start.offset !== b.position.start.offset) return a.position.start.offset - b.position.start.offset
  return a.position.end.offset - b.position.end.offset
}
